import { Subscriber, } from "rxjs";
export function unsubscribeOn(scheduler, delay = 0) {
    return (source) => source.lift(new UnsubscribeOnOperator(scheduler, delay));
}
class UnsubscribeOnOperator {
    constructor(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    call(subscriber, source) {
        return source.subscribe(new UnsubscribeOnSubscriber(subscriber, this.scheduler, this.delay));
    }
}
class UnsubscribeOnSubscriber extends Subscriber {
    constructor(destination, scheduler, delay) {
        super(destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    unsubscribe() {
        const { delay, scheduler } = this;
        scheduler.schedule(() => super.unsubscribe(), delay);
    }
}
//# sourceMappingURL=unsubscribeOn.js.map